// extracted by mini-css-extract-plugin
export default {"main":"DocumentPage_main__yAWZt"};